import 'react';
import { useFormState } from '../hooks/useFormState.js';

// eslint-disable-next-line no-unused-vars
var FormStateAccessor = function FormStateAccessor(_ref) {
  var children = _ref.children;
  var formState = useFormState();
  return children(formState);
};

export { FormStateAccessor };
